import { render, staticRenderFns } from "./DigitalTransformation.vue?vue&type=template&id=fdd4d568&scoped=true"
import script from "./DigitalTransformation.vue?vue&type=script&lang=js"
export * from "./DigitalTransformation.vue?vue&type=script&lang=js"
import style0 from "./DigitalTransformation.vue?vue&type=style&index=0&id=fdd4d568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd4d568",
  null
  
)

export default component.exports